import ClientBidDetailsPage from '@/pages/ClientBidDetailsPage'

export default {
    path: '/cases/:caseId/bids/:bidId',
    name: 'cases.bids.show',
    component: ClientBidDetailsPage,
}